import React from 'react';

import styles from './root.scss';

interface AccordionRootProps {
  children: React.ReactNode;
}

function AccordionRoot(props: AccordionRootProps) {
  return <div className={styles.wrapper}>{props.children}</div>;
}

export default AccordionRoot;
